import NotificationCardWrapper from "../NotificationCardWrapper";
import { Box, Button } from "@mui/material";

import Info from "../../../../media/svg/Info";

const ReportAccount = () => {
  return (
    <NotificationCardWrapper
      firstChild={<Info style={{ width: "20px", height: "20px" }} />}
      seccondChild={
        <Box>Your account has been reported, please review your profile</Box>
      }
      ThirdChild={
        <Button
          variant='contained'
          color='primary'
          size='small'
          sx={{
            border: "2px solid",
            borderColor: "black.main",
            boxShadow: ` 0px 2px 0px black`,
            borderRadius: "8px",
            fontSize: "12px",
            fontWeight: "600",
            alignItems: "center",
            height: "32px",
            minWidth: "95px",
            paddingTop: "8px",
            // paddingY: "7px",
            // paddingX: 0,
            "&.MuiButtonBase-root:hover": {
              border: "2px solid",
              backgroundColor: "primary.main",
              boxShadow: ` 0px 2px 0px black`,
            },
            "&.MuiButtonBase-root:active": {
              backgroundColor: "black.main",
              color: "white.main",
              boxShadow: "none",
            },
          }}
        >
          Edit profile
        </Button>
      }
    />
  );
};

export default ReportAccount;
